import React, { useState, useEffect } from "react";
import { MemoryRouter } from "react-router-dom";
import ProgressBar from "../checkout-progress-bar";
import DeliveryOptions from "../delivery-options";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import BillingInfo from "../billing-info-12";
import SimpleLink from "../../elements/simple-link";
import Checkbox from "../../elements/checkbox";
import ContactInformation from "../contact-information";
import PrimaryButton from "../../elements/primary-button";
import OrderSummary from "../checkout-order-summary";
import { setBillingInfoAction, setContactInfoAction, setDiffAddrAction, setShippingInfoAction } from "../../redux/actions/gears-checkout";
import { selectUserState } from "../../selectors/application";
import { billingInfoSelector, contactInfoSelector, diffAddrSelector, shippingInfoSelector } from "../../selectors/gears-checkout";
import { connect } from "react-redux";
import ShippingInfo from "../shipping-info";
import { InstantCode } from "../../utils/lynkco-constants";

const InStoreCheckoutView = ({ page, heading, billingInfo, shippingInfo, contactInfo, orderSummary, changeMarket, billingCheckbox, deliveryInfo, onCheckoutViewInit, barProps, userInfo, contactInfoData, setBillingFormData, setShippingFormData, setContactFormData, setDiffAddr }) => {
  const [showBillingInfo, setShowBillingInfo] = useState(false);
  const [isInstant, setIsInstant] = useState(true);
  const { gearsPaymentLink } = page.fields;
  const billingInfoRef = React.createRef();
  const shippingInfoRef = React.createRef();
  const contactInfoRef = React.createRef();
  const toggleBillingInfo = () => {
    setDiffAddr(!showBillingInfo);
    setShowBillingInfo(!showBillingInfo);
  };
  useEffect(() => {
    onCheckoutViewInit(true);
  }, []);
  useEffect(() => {
    setIsInstant(deliveryInfo.selectedOption?.code === InstantCode);
  }, [deliveryInfo]);
  const onSubmit = evt => {
    let billingFormData = null,
      shippingFormData = null,
      contactFormData = null;
    let valid = true;
    if (!isInstant) {
      const sResult = shippingInfoRef.current.validateForm();
      shippingFormData = sResult.formData;
      valid &= sResult.isValid;
      if (showBillingInfo) {
        const billingForm = billingInfoRef.current.validateForm();
        billingFormData = billingForm.formData;
        valid &= billingForm.isValid;
      } else {
        billingFormData = shippingFormData;
      }
      const cResult = contactInfoRef.current.validateForm();
      contactFormData = cResult.formData;
      valid &= cResult.isValid;
    }
    if (valid) {
      setBillingFormData(billingFormData);
      setShippingFormData(shippingFormData);
      setContactFormData(contactFormData);
      window.location.href = gearsPaymentLink.value.href;
    }
  };
  const shippingInfoProps = {
    ...shippingInfo,
    visible: !isInstant,
    ref: shippingInfoRef
  };
  const billingInfoProps = {
    ...billingInfo,
    visible: showBillingInfo && !isInstant,
    ref: billingInfoRef
  };
  return (
    <section className="checkout-delivery grid">
      <div className="shipping-address-section">
        <MemoryRouter>
          <ProgressBar {...barProps} />
        </MemoryRouter>
        <DeliveryOptions {...deliveryInfo} />
        {heading && !isInstant && (
          <div className="heading">
            <Heading {...heading} />
          </div>
        )}

        {userInfo?.email?.html && (
          <div className="info-container">
            <BodyText html={userInfo.email.html} className="userInfo" />
          </div>
        )}
        <ShippingInfo {...shippingInfoProps} />
        {shippingInfo && !isInstant && (
          <div>
            <div className="info-container">
              <BodyText html={userInfo.country.html} className="userInfo" />
              <SimpleLink {...changeMarket} />
            </div>
            <Checkbox
              {...{
                ...billingCheckbox,
                onChange: toggleBillingInfo,
                checked: showBillingInfo
              }}
            />
          </div>
        )}
        <div className="billing-address">
          <BillingInfo {...billingInfoProps} />
        </div>
        {contactInfo && !isInstant && <ContactInformation {...{ ...contactInfo, formData: contactInfoData }} ref={contactInfoRef} />}
        <PrimaryButton {...{ ...deliveryInfo.submit, callback: evt => onSubmit(evt) }} />
      </div>
      <div className="summary-section">
        <OrderSummary {...orderSummary} />
      </div>
    </section>
  );
};
const mapStateToProps = state => ({
  user: selectUserState(state),
  diffAddr: diffAddrSelector(state),
  shippingInfoData: shippingInfoSelector(state),
  billingInfoData: billingInfoSelector(state),
  contactInfoData: contactInfoSelector(state)
});
const mapDispatchToProps = dispatch => ({
  setBillingFormData: data => dispatch(setBillingInfoAction(data)),
  setShippingFormData: data => dispatch(setShippingInfoAction(data)),
  setDiffAddr: data => dispatch(setDiffAddrAction(data)),
  setContactFormData: data => dispatch(setContactInfoAction(data))
});
export default connect(mapStateToProps, mapDispatchToProps)(InStoreCheckoutView);
